import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { userDetailClientListCol } from "../../appconfig/DatatableSetting";
import { Column } from "primereact/column";
import {
  formatMonthYear,
  formatMonthYearUtc,
  globalNameFilterTemplate,
} from "../../appconfig/AppHelper";
import Loader from "../../components/Loader/Loader";
import {
  getAllDetails,
  getSpecificDetails,
} from "../../service/ProductService";
import { GET_USER_CLIENT_PAYMENT_DETAILS } from "../../config/ApiConstant";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import {
  dateMonthYearTemplate,
  dollarTemplate,
} from "../../appconfig/TemplateFieldSetting";

const UserDetailsDashboard = () => {
  document.title = "Clients | Nexawage Payroll";
  const toast = useRef<any>(null);

  //   get month year using location
  const location: any = useLocation();
  const monthYear = location?.state?.monthYear;
  const monthYearToPass = moment(monthYear).format("YYYY-MM");

  const { id }: any = useParams();
  const user_id = id
    ? (() => {
        try {
          return atob(id);
        } catch {
          return null;
        }
      })()
    : null;

  // user Details
  const [userDetails, setUserDetails] = useState<any>(null);

  //   page load
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  //   client list
  const [clientList, setClientList] = useState<any>([]);

  // filter
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    company_name: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    name: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  useEffect(() => {
    getClientList();
  }, []);

  // get client list api
  const getClientList = async () => {
    try {
      setPageLoad(false);
      const response = await getAllDetails(
        `${GET_USER_CLIENT_PAYMENT_DETAILS}?month_year=${monthYearToPass}&user_id=${user_id}`
      );

      //Check Id Base Response
      let data = response;

      //Check Id Base Response Set
      if (data) {
        setUserDetails(data?.user);

        setClientList(data?.client_list);
        setPageLoad(true);
      } else {
        setClientList([]);
        setUserDetails(null);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={globalFilter || ""}
          onInput={(e) => setGlobalFilter(e.currentTarget.value)}
          placeholder="Search..."
        />
      </span>
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <Button
        icon="pi pi-filter-slash"
        label="Clear"
        onClick={clearAll}
        className="mr-2 p-button-outlined common-p-outline-button"
      />
    </>
  );

  return (
    <>
      <AppBreadcrumb
        currentMenu="Client"
        pageName="List"
        pageTitle={`Client Charge Payment Of ${
          userDetails?.first_name || "-"
        } ${userDetails?.last_name || "-"} For ${formatMonthYearUtc(
          monthYear
        )} `}
        goToPage={true}
      />

      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo relative">
            {userDetails && (
              <>
                <div className="grid">
                  <div className="col-12 md:col-12">
                    <div className="grid p-fluid">
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Name:</label>
                        <div>
                          {userDetails?.first_name || "-"}{" "}
                          {userDetails?.last_name || "-"}
                        </div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Email:</label>
                        <div>{userDetails?.email || "-"}</div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Phone:</label>
                        <div>{userDetails?.phone || "-"}</div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>
                          Postal Code:
                        </label>
                        <div>{userDetails?.postal_code || "-"}</div>
                      </div>

                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Address:</label>
                        <div>{userDetails?.address || "-"}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <h5 className="mb-3">Clients List</h5>
              </>
            )}
            <Toast ref={toast} />
            <Toolbar
              className="gap-3"
              left={leftToolbarTemplate}
              right={rightToolbarTemplate}
            />
            {pageLoad ? (
              <DataTable
                value={clientList}
                showGridlines
                dataKey="id"
                responsiveLayout={"scroll"}
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={clientList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Clients"}
                emptyMessage="No Clients Found"
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                removableSort
              >
                {userDetailClientListCol.map((col: any, i: any) => {
                  if (col.field === "name") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  } else if (col.field === "company_name") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  } else if (col.field === "email") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  } else if (col.field === "client_charge") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dollarTemplate}
                      />
                    );
                  } else if (col.field === "client_subs_month_year") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dateMonthYearTemplate}
                      />
                    );
                  } else if (col.field === "phone") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  } else {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {userDetailClientListCol.map((col: any) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={SkeletonbodyTemplate}
                  />
                ))}
              </DataTable>
            )}

            {pageLoad === false && user_id && <Loader />}
          </Card>
        </div>
      </div>
    </>
  );
};

export default UserDetailsDashboard;
